import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Button from '../../button';
import Icon from '../../icon';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const FilterPanel = ({ elmId = 'filter_panel', showCloseButton = false, onOpen, onReset, children, }) => {
    const content = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { elmId: `${elmId}_content` });
        }
        return child;
    });
    return (_jsxs("div", { className: cx('panel'), children: [showCloseButton && (_jsx(Icon, { "data-elm-id": `${elmId}_close_button`, className: cx('close-button'), name: 'times', iconStyle: 'regular', fitted: true, size: 'large', onClick: () => onOpen(false) })), _jsx("div", { className: cx('content'), children: content }), _jsxs("div", { className: cx('footer'), children: [_jsx(Button, { "data-elm-id": `${elmId}_reset_button`, className: cx('reset-button'), onClick: onReset, children: "Reset" }), _jsx(Button, { "data-elm-id": `${elmId}_done_button`, role: 'primary', className: cx('done-button'), onClick: () => onOpen(false), children: "Done" })] })] }));
};
export default FilterPanel;
//# sourceMappingURL=index.js.map